<header class="product-header" (click)="onEdit()">
  @let image = productImage();

  @if (displayImage()) {
    @if (image) {
      <figure class="product-header__thumb">
        <pxw-image
          [src]="image"
          [imageSize]="50"
          [objectFit]="'cover'"
          [width]="50"
          [aspectRatio]="1"
          [lazyLoad]="false"
          [alt]="productName()"
        />
      </figure>
    } @else {
      <div class="product-header__thumb product-header__thumb--placeholder">
        {{ withoutImageLabel() }}
      </div>
    }
  }
  <div class="product-header__title">
    @if (displaySku() && productSku()) {
      <p class="product-header__sku">{{ productSku() }}</p>
    }
    <h3 class="product-header__name">{{ productName() }}</h3>
    @if (!isCategoryAvailable()) {
      <pxw-tag
        class="product-header__not-available"
        size="xs"
        type="warning"
        style="margin-bottom: 0.2em"
        (click)="$event.stopPropagation(); openAvailability.emit()"
      >
        <pxw-icon icon="clock" />
        {{ notAvailableLabel() }}
      </pxw-tag>
    } @else if (isProductUnavailable()) {
      <pxw-tag
        class="product-header__not-available"
        size="xs"
        type="warning"
        style="margin-bottom: 0.2em"
      >
        <pxw-icon icon="alert" />
        {{ productNotAvailableLabel() }}
      </pxw-tag>
    } @else if (warningNote(); as note) {
      <p class="product-header__warning-note">
        <pxw-icon icon="alert" size="xs" />
        {{ note }}
      </p>
    }
  </div>
  @if (!readOnly() && !isCategoryAvailable()) {
    <button
      type="button"
      class="product-header__remove"
      (click)="$event.stopPropagation(); removeAll.emit()"
    >
      <pxw-icon icon="trash-can" size="sm" />
    </button>
  }
</header>
